import {searchSpells} from "@/spells/SpellApi.ts";
import {SpellSummary} from "@/spells/model/Spell.ts";
import SearchPopover from "@/search/SearchPopover.tsx";
import SpellSearchResultEntry from "@/search/SpellSearchResultEntry.tsx";
import {Button} from "@/components/ui/button.tsx";
import {Plus} from "lucide-react";

export default function SpellSearchView({level, addSpell}: {
    level: number | undefined;
    addSpell: (spell: SpellSummary) => void;
}) {
    return <SearchPopover<SpellSummary>
        placeholder="Zauber suchen"
        minQueryLength={1}
        requestKey={level ?? "all"}
        className="w-auto"
        contentClassName="w-[min(24rem,calc(100vw-1rem))]"
        trigger={<Button type="button" size="sm" variant="outline"><Plus/> Zauber</Button>}
        search={(query, signal) => searchSpells({page: 0, size: 15}, {name: query, level}, signal)}
        getKey={spell => spell.id}
        onSelect={addSpell}
        renderItem={({item: spell, query, select, selecting}) => (
            <SpellSearchResultEntry spell={spell} query={query} onSelect={select} selecting={selecting}
                                    actionLabel={`${spell.name} hinzufügen`}/>
        )}
    />;
}
